import Vue from 'vue'
import Vuex from 'vuex'

import stepperModule from './stepper.module'
import appModule from './app.module'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    stepper: stepperModule,
    app: appModule,
  },
})
